import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const TimepickerHeaderWrapper = styled.div`
  display: block;
  text-align: center;
  align-items: center;
  justify-content: space-between;
  padding: 4px 0;
  width:100%; margin-bottom:16px; 
`;

const Button = styled.button`
  width: 56px;
  height: 45px;
  border-radius: 4px;
  border: solid 1px #e9eff4;
  display: inline-block;
  position: relative;
  cursor: pointer;
  font-size:  16px;
  background:${props => props.active ? '#f4f8f9' : '#ffffff'};
  @media(min-width: 800px) {
    width: 102px;
    height: 45px;
  }
  &:nth-child(1){
    border-radius:4px 0 0 4px;
    border-right:0;
  }
  &:nth-child(1):after {
    content:''; 
    background:#979797; 
    opacity:0.4;
    width: 1px;
    height: 24px;
    position: absolute;
    right: 0;
    top: 10px;
  }
  &:nth-child(2){
    border-radius:0 4px 4px 0;
    border-left:0;
  }
`;

const TimepickerHeader = (props) => {
  return (
    <TimepickerHeaderWrapper>
      <Button
        onClick={() => props.handleTimePeriod("AM")}
        title="AM"
        active={props.selectedTimePeriod === "AM" ? true : false}
      >
        AM
      </Button>
      <Button
        onClick={() => props.handleTimePeriod("PM")}
        title="PM"
        active={props.selectedTimePeriod === "PM" ? true : false}
      >
        PM
      </Button>
    </TimepickerHeaderWrapper>
  )
}

TimepickerHeader.propTypes = {
  handleTimePeriod: PropTypes.func,
  selectedTimePeriod: PropTypes.string
};

TimepickerHeader.defaultProps = {
  selectedTimePeriod: "AM"
};

export default TimepickerHeader;


// WEBPACK FOOTER //
// ./src/components/UI/TimePicker/TimepickerHeader.js